// extracted by mini-css-extract-plugin
export default {"cls1":"Q8kHOFHT7FjHFpmWtYrK","cls2":"wzsbjQPYb87n6XAOeBBg Q8kHOFHT7FjHFpmWtYrK","isPhone":"eRTkHUZlXIAqVWbTbNVt"};